import { Grid } from '@mui/material';
import { BooleanInput, Edit, ReferenceArrayInput, SelectArrayInput, SimpleForm, TextInput } from 'react-admin';

const EmailGroupEdit = () => {
	return (
		<Edit>
			<SimpleForm>
				<Grid container spacing={2}>
					<Grid item xs={12} md={2}>
						<TextInput source="groupId" fullWidth disabled />
					</Grid>
					<Grid item xs={12} md={4}>
						<TextInput source="name" fullWidth />
					</Grid>
					<Grid item xs={12} md={2}>
						<BooleanInput source="allCompanies" />
					</Grid>
					<Grid item xs={12} md={6}>
						<ReferenceArrayInput
							perPage={999}
							sort={{ field: 'english_name', order: 'ASC' }}
							reference="company"
							source="excludeCompanies"
						>
							<SelectArrayInput label="חברות לא כלולות" optionText={'english_name'} fullWidth />
						</ReferenceArrayInput>
					</Grid>
					<Grid item xs={12} md={6}>
						<ReferenceArrayInput
							sort={{ field: 'english_name', order: 'ASC' }}
							perPage={999}
							reference="company"
							source="includeCompanies"
						>
							<SelectArrayInput label="חברות כלולות" optionText={'english_name'} fullWidth />
						</ReferenceArrayInput>
					</Grid>
				</Grid>
			</SimpleForm>
		</Edit>
	);
};

export default EmailGroupEdit;
